import type * as React from 'react';

function SvgMore(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg height="1em" viewBox="0 0 20 20" width="1em" {...props}>
      <path
        d="M11 9h8a1 1 0 010 2h-8v8a1 1 0 01-2 0v-8H1a1 1 0 010-2h8V1a1 1 0 012 0v8z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgMore;
